import {PlanCodeItem} from 'ApplicationEntry/models/PlanCodes';
import {GroupDisability} from 'ApplicationEntry/models/ProductsRiders/Disability/GroupDisability';
import {NewYorkDisability} from 'ApplicationEntry/models/ProductsRiders/Disability/NewYorkDisability';
import {OrdDisability} from 'ApplicationEntry/models/ProductsRiders/Disability/OrdinaryDisability';

export type Disability = OrdDisability | GroupDisability | NewYorkDisability;

type ExhaustiveDisabilityOptionsByType<TReturn> = {
  Ordinary: (ordinary: OrdDisability) => TReturn;
  Group: (group: GroupDisability) => TReturn;
  NewYork: (newYork: NewYorkDisability) => TReturn;
};

type PartialDisabilityOptionsByType<TReturn> = {
  Ordinary?: (ordinary: OrdDisability) => TReturn;
  Group?: (group: GroupDisability) => TReturn;
  NewYork?: (newYork: NewYorkDisability) => TReturn;
  _: (app: Disability) => TReturn;
};

const isExhaustiveByType = <TReturn>(
  options: DisabilityByTypeOptions<TReturn>
): options is ExhaustiveDisabilityOptionsByType<TReturn> => !!options.Ordinary || (!!options.Group && !!options.NewYork);

type DisabilityByTypeOptions<TReturn> = PartialDisabilityOptionsByType<TReturn> | ExhaustiveDisabilityOptionsByType<TReturn>;

export const matchDisabilityByType = <TReturn>(options: DisabilityByTypeOptions<TReturn>) => (app: Disability): TReturn => {
  switch (app.key) {
    case 'InvalidOrdDisability':
    case 'ValidOrdDisability':
      return isExhaustiveByType(options)
        ? options.Ordinary(app)
        : options.Ordinary
        ? options.Ordinary(app)
        : options._(app);
    case 'InvalidGroupDisability':
    case 'ValidGroupDisability':
      return isExhaustiveByType(options) 
      ? options.Group(app) 
      : options.Group 
      ? options.Group(app) 
      : options._(app);
    case 'InvalidNewYorkDisability':
    case 'ValidNewYorkDisability':
      return isExhaustiveByType(options)
        ? options.NewYork(app)
        : options.NewYork
        ? options.NewYork(app)
        : options._(app);
  }
};

export const isValidDisability = (disability: Disability) =>
  disability.key === 'ValidOrdDisability' ||
  disability.key === 'ValidGroupDisability' ||
  disability.key === 'ValidNewYorkDisability';

  type riderList = {
    code: string;
    units: number;
  };
  
  export const handleRidersInQuality = (planCodes: PlanCodeItem[]) => {
    const ridersList: riderList[] = [];
    planCodes.forEach((planCode, index) => {
      const riders = {} as riderList;
      if (index !== 0) {
        riders.code = planCode.tracInputL70;
        riders.units = planCode.units;
  
        ridersList.push(riders);
      }
    });

    return ridersList;
  };